export default __webpack_public_path__ + "static/media/festival.bc31dfc4.svg";